import { useSession } from "../shell/store";
import { useCan } from "./access";
import { ApiError } from "./api";
import { useNavigate } from "./nav";

/** M7 round six, the refusals' way up (brief task 5: "The refusals elsewhere … link here with the plan named"): a plan refusal's toast
 *  carries the API's message (the plan and the way up) and, for a person who may buy (the `billing` capability), the action "See plans",
 *  which opens Settings › Billing with the Change plan dialog. Everyone else gets the message alone: they cannot buy. */
const PLAN_REFUSALS = ["plan_limit", "plan_feature"];
/** our API's codes are lower case, Better Auth's (the invitation) upper case */
export const isPlanRefusal = (code: unknown): boolean => typeof code === "string" && PLAN_REFUSALS.includes(code.toLowerCase());
export const plansPath = (slug: string): string => `/${slug}/settings/billing?plans=1`;
/** long enough to read two sentences and reach the action */
const PLAN_TOAST_MS = 8_000;

export function useRefusalToast(): (message: string, code?: unknown) => void {
  const { workspace, toast } = useSession();
  const can = useCan();
  const navigate = useNavigate();
  return (message, code) => {
    if (!isPlanRefusal(code) || !can("billing")) { toast(message); return; }
    toast(message, { kind: "warning", action: { label: "See plans", onClick: () => navigate(plansPath(workspace.slug)) } }, PLAN_TOAST_MS);
  };
}
/** an error's toast: our API's message (a plan refusal's with the way up), else a plain apology */
export function useErrorToast(): (e: unknown) => void {
  const refused = useRefusalToast();
  return (e) => (e instanceof ApiError ? refused(e.message, e.code) : refused("Something went wrong"));
}
